import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Users from './pages/Users';
import RulesConfig from './pages/RulesConfig';
import Submissions from './pages/Submissions';

function App() {
  return (
    <Router>
      <div className="App">
        <main className="content">
          <Routes>
            <Route path="/" element={<Navigate to="/submissions" replace />} />
            <Route path="/rules" element={<RulesConfig />} />
            <Route path="/submissions" element={<Submissions />} />
            <Route path="/users" element={<Users />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
